import React from "react";
import "../assets/css/skills.scss";
import "../App.css";
import skillGroups from "../assets/skills.json";

const Skills = () => {
  return (
    <section id="skills">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Tech Stack</span>
          <h1 className="section-title">Skills</h1>
        </div>

        <div className="skills-groups">
          {skillGroups.map((group) => (
            <div className="skills-group" key={group.group}>
              <div className="group-header">
                <span className="group-label">{group.group}</span>
              </div>
              <div className="skills-container">
                {group.skills.map((skill) => (
                  <div className="skill-card glass-panel" key={skill.name}>
                    <img
                      src={skill.src}
                      className="skill-logo"
                      alt={skill.alt}
                    />
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
